module.exports = __webpack_public_path__ + "static/media/blingV3_17.5718bf3e.png";